import _, { get, includes } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import { withComponentId } from '../../../common/ComponentIdContext';
import { withComponentName } from '../../../common/ComponentNameContext';
import { TYPE_DISABLE } from '../../../common/sync-component/Const';
import { cellNegtiveRed } from '../../../common/table/CustomCellTable';
import { getColorPrice } from '../../../helpers/Color';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../../helpers/EventEmitter';
import {
  formatPercent,
  formatPrice,
  formatTextFloat,
  formatValueBillion,
} from '../../../helpers/Text';
import Table from '../../../common/table/Table';
import {
  getDataFollowKeyByDot,
  getDefaultSyncType,
  syncComponentSelector,
} from '../../../helpers/Common';
import CellHover from '../../watchlist/summary/CellHover';
import TextBlink from '../../../common/table/TextBlink';
import TradingViewUrl from '../../../common/TradingViewUrl';
import SectorName from './SectorName';

const getClassName = (item, listColumn) => {
  return getColorPrice(
    getDataFollowKeyByDot(item, listColumn.PRICE),
    getDataFollowKeyByDot(item, listColumn.REF_PRICE),
    getDataFollowKeyByDot(item, listColumn.HIGH_PRICE),
    getDataFollowKeyByDot(item, listColumn.LOW_PRICE),
    'text',
  );
};

const schema = (listColumn, i18nTitleKey) =>
  Object.keys(listColumn).map((item, index) => {
    const key = listColumn[item];
    const title = `${i18nTitleKey}.${item}`;

    const result = {
      key,
      title,
    };

    if (index === 0) {
      return {
        ...result,
        isString: true,
        render: (text, item) => (
          <CellHover organCode={item.organCode} isShowDeleteIcon={false}>
            <TextBlink item={item} tradingDate="tradingDate">
              <TradingViewUrl code={item.organCode} />
              &nbsp;{text}
            </TextBlink>
          </CellHover>
        ),
      };
    }

    if (_.includes([listColumn.PRICE], key)) {
      return {
        ...result,
        render: (text, item) => {
          const className = getClassName(item, listColumn);
          return (
            <TextBlink
              item={item}
              tradingDate="tradingDate"
              className={className}
            >
              {formatTextFloat(formatPrice(text))}
            </TextBlink>
          );
        },
      };
    }

    if (
      _.includes([listColumn.EBIT_MARGIN, listColumn.NET_PROFIT_GROWTH], key)
    ) {
      return {
        ...result,
        render: text => (
          <div className="pl-8 pr-8">{formatPercent(text)} %</div>
        ),
      };
    }

    if (_.includes([listColumn.PERCENT_PRICE_CHANGE], key)) {
      return {
        ...result,
        render: (text, item) => {
          const className = getClassName(item, listColumn);
          return (
            <TextBlink
              item={item}
              tradingDate="tradingDate"
              className={className}
            >
              {formatTextFloat(text * 100)}%
            </TextBlink>
          );
        },
      };
    }

    if (listColumn.SECTOR_NAME === key) {
      return {
        ...result,
        isString: true,
        thStyle: { textAlign: 'left' },
        render: (text, item, width) => {
          return <SectorName width={width}>{text}</SectorName>;
        },
      };
    }

    if (_.includes([listColumn.ISA3], key)) {
      return {
        ...result,
        render: text => (
          <TextBlink item={item} tradingDate="tradingDate">
            {formatTextFloat(formatValueBillion(text), 0)}
          </TextBlink>
        ),
      };
    }

    if (_.includes([listColumn.ISA20], key)) {
      return {
        ...result,
        render: text => (
          <TextBlink item={item} tradingDate="tradingDate">
            {cellNegtiveRed(formatValueBillion(text), 0)}
          </TextBlink>
        ),
      };
    }

    if (_.includes([listColumn.RTD14], key)) {
      return {
        ...result,
        render: text => (
          <TextBlink item={item} tradingDate="tradingDate">
            {cellNegtiveRed(formatTextFloat(text, 0))}
          </TextBlink>
        ),
      };
    }

    if (_.includes([listColumn.RTD7], key)) {
      return {
        ...result,
        render: text => (
          <TextBlink item={item} tradingDate="tradingDate">
            {formatTextFloat(text, 0)}
          </TextBlink>
        ),
      };
    }

    return {
      ...result,
      render: text => (
        <TextBlink item={item} tradingDate="tradingDate">
          {cellNegtiveRed(text)}
        </TextBlink>
      ),
    };
  });

class TableFinancial extends Component {
  onRowClick = organCode => {
    const { listOrganizationByOrganCode, syncType } = this.props;
    if (syncType === TYPE_DISABLE) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      syncType: syncType,
      search: listOrganizationByOrganCode[organCode],
    });
  };

  render() {
    const {
      listId,
      listColumns,
      getDataFromRedux,
      hideColumns,
      i18nTitleKey,
      isLoading,
      table,
      onSort,
      sortState,
      widths,
    } = this.props;

    return (
      <Table
        clickRow={this.onRowClick}
        onSort={onSort}
        sortState={sortState}
        table={table}
        thValign="top"
        isLoading={isLoading}
        ids={listId}
        resizable={true}
        columnDraggable={false}
        rowDraggable={false}
        hideColumns={hideColumns}
        getDataFromRedux={getDataFromRedux}
        schema={schema(listColumns, i18nTitleKey)}
        widths={widths}
      />
    );
  }
}

const mapStateToProps = (state, { componentName, componentId }) => {
  return {
    listOrganizationByOrganCode:
      state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
    syncType: syncComponentSelector(state, componentName, componentId),
  };
};

export default compose(
  withComponentId,
  withComponentName,
  connect(mapStateToProps),
)(TableFinancial);
